import { uuidv4 } from "./util";
import {
  BotResponseMessage,
  INCOMING_BOT_RESPONSE,
  IncomingMessageBotResponseContent,
  OUTGOING_BOT_QUERY,
  WebSocketHandler,
} from "./ws";
import { marked } from "marked";

type MessageKind = "system" | "bot" | "user";

class Message {
  id: string;
  kind: MessageKind;
  content: string;
  date: Date;

  constructor(kind: MessageKind, content: string, id?: string) {
    this.kind = kind;
    this.content = content;
    this.date = new Date();
    this.id = id ?? uuidv4();
  }

  isSystem() {
    return this.kind === "system";
  }

  from() {
    switch (this.kind) {
      case "bot":
        return "DwayneBot";
      case "user":
        return "You";
      default:
        return "";
    }
  }

  classname() {
    switch (this.kind) {
      case "system":
        return "system-message";
      case "bot":
        return "bot-message";
      case "user":
        return "user-message";
    }
  }
}

export async function activateBotControl() {
  const ws = new WebSocketHandler();
  const iconContainer = document.querySelector(".bot-icon-container");
  const panelContainer = document.getElementById("bot-panel");
  const messageContainer = document.getElementById(
    "bot-panel-message-container",
  );
  const sendButton = document.getElementById("bot-panel-send-button");
  const minimizeButton = document.getElementById("bot-panel-minimize-button");
  const messageInput = document.getElementById(
    "bot-panel-message-input",
  ) as HTMLTextAreaElement | null;

  let panelVisible = false;
  const cid = uuidv4();

  async function renderMessage(message: BotResponseMessage) {
    switch (message.contentType) {
      case 1:
        return await marked.parse(message.content);
      default:
        return message.content;
    }
  }

  async function handleBotMessage(content: any) {
    const message = (content as IncomingMessageBotResponseContent).message;
    if (message) {
      const messageContent = await renderMessage(message);
      addToConversation(new Message("bot", messageContent, message.messageId));
    }
  }

  function addToConversation(message: Message) {
    if (messageContainer) {
      const messageElement = document.createElement("div");
      messageElement.className = message.classname();

      const contentContainer = document.createElement("div");
      contentContainer.innerHTML = message.content;
      messageElement.appendChild(contentContainer);

      if (!message.isSystem()) {
        const footer = document.createElement("footer");
        footer.className = "message-footer";

        const from = document.createElement("div");
        from.className = "from";
        from.innerText = message.from();

        const time = document.createElement("time");
        time.innerText = message.date.toDateString();

        footer.appendChild(from);
        footer.appendChild(time);

        messageElement.appendChild(footer);
      }

      messageContainer.appendChild(messageElement);
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  }

  function handleSend() {
    if (messageInput) {
      if (ws.isOpen() && messageInput.value) {
        ws.send({
          kind: OUTGOING_BOT_QUERY,
          content: {
            cid,
            message: messageInput.value,
          },
        });

        addToConversation(new Message("user", messageInput.value));
        messageInput.value = "";
      }
    }
  }

  if (messageInput) {
    messageInput.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleSend();
      }
    });
  }

  if (minimizeButton) {
    minimizeButton.addEventListener("click", () => {
      if (panelContainer) {
        panelContainer.classList.add("hidden");
        panelVisible = false;
      }
    });
  }

  if (sendButton) {
    sendButton.addEventListener("click", handleSend);
  }

  if (iconContainer) {
    iconContainer.classList.remove("hidden");
    const button = iconContainer.querySelector("button");
    if (button) {
      button.addEventListener("click", async () => {
        if (panelContainer) {
          if (panelVisible) {
            panelContainer.classList.add("hidden");
            panelVisible = false;
          } else {
            panelContainer.classList.remove("hidden");
            panelVisible = true;

            if (!ws.isOpen()) {
              console.log("about to connect");
              ws.addMessageListener(INCOMING_BOT_RESPONSE, handleBotMessage);
              ws.addConnectionListener(() => {
                console.log("about to add to conversation");
                addToConversation(
                  new Message("system", "Connected to WebSocket"),
                );
              });
              await ws.connect();
            }
          }
        }
      });
    }
  }
}
